module.exports = __webpack_public_path__ + "media/images/icons/camera-95ba4fe58c43337441bd730facaf9b2b.svg";